import { createSelector } from 'reselect';

const selectAdminLevelPincode = (state: any) => state.AdminLevelPincode;


export const selectAdminLevelPincodeCurrentItem = createSelector([selectAdminLevelPincode], (AdminLevelPincode) => AdminLevelPincode.current);

export const selectAdminLevelPincodeListItems = createSelector([selectAdminLevelPincode], (AdminLevelPincode) => AdminLevelPincode.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectAdminLevelPincodeListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAdminLevelPincodeQueryItems = createSelector([selectAdminLevelPincode], (AdminLevelPincode) => AdminLevelPincode.query);

export const selectAdminLevelPincodeCreatedItem = createSelector([selectAdminLevelPincode], (AdminLevelPincode) => AdminLevelPincode.create);

export const selectAdminLevelPincodeUpdatedItem = createSelector([selectAdminLevelPincode], (AdminLevelPincode) => AdminLevelPincode.update);

export const selectAdminLevelPincodeReadItem = createSelector([selectAdminLevelPincode], (AdminLevelPincode) => AdminLevelPincode.read);

export const selectAdminLevelPincodeDeletedItem = createSelector([selectAdminLevelPincode], (AdminLevelPincode) => AdminLevelPincode.delete);

export const selectAdminLevelPincodeSearchedItems = createSelector([selectAdminLevelPincode], (AdminLevelPincode) => AdminLevelPincode.search);

export const selectAdminLevelPincodeItemsCount = createSelector([selectAdminLevelPincode], (AdminLevelPincode) => AdminLevelPincode.count);

export const selectAdminLevelPincodeItemsFilter = createSelector([selectAdminLevelPincode], (AdminLevelPincode) => AdminLevelPincode.filter);